/* Yuvakart — tap-to-copy coupon code on the product page.

   The offer strip renders its code as plain text ("Use code YUVA200").
   This finds that code, turns it into a copy chip, and copies it to
   the clipboard on tap with a confirmation state. No section markup
   is edited, so it keeps working if the offer text changes. */
(function(){

  var RE = /\bcode\s+([A-Z0-9][A-Z0-9._-]{2,19})\b/i;

  function icon(){
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
           '<rect x="9" y="9" width="12" height="12" rx="2"/>' +
           '<path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1"/></svg>';
  }
  function tick(){
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">' +
           '<path d="M20 6L9 17l-5-5"/></svg>';
  }

  function copy(text){
    if (navigator.clipboard && navigator.clipboard.writeText){
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function(resolve, reject){
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '-1000px';
        document.body.appendChild(ta);
        ta.select();
        ta.setSelectionRange(0, ta.value.length);
        document.execCommand('copy');
        document.body.removeChild(ta);
        resolve();
      } catch(e){ reject(e); }
    });
  }

  function makeChip(code){
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ykcpn';
    b.setAttribute('data-code', code);
    b.setAttribute('aria-label', 'Copy discount code ' + code);
    b.innerHTML = '<span class="ykcpn__t">' + code + '</span><span class="ykcpn__i">' + icon() + '</span>';

    b.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      copy(code).then(function(){
        b.classList.add('is-copied');
        b.querySelector('.ykcpn__t').textContent = 'Copied';
        b.querySelector('.ykcpn__i').innerHTML = tick();
        setTimeout(function(){
          b.classList.remove('is-copied');
          b.querySelector('.ykcpn__t').textContent = code;
          b.querySelector('.ykcpn__i').innerHTML = icon();
        }, 1800);
      }).catch(function(){
        b.querySelector('.ykcpn__t').textContent = code;
      });
    });

    return b;
  }

  function scan(root){
    if (!root || root.getAttribute('data-ykcpn')) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var node, target = null, match = null;

    while ((node = walker.nextNode())){
      if (node.parentNode && node.parentNode.closest && node.parentNode.closest('.ykcpn')) continue;
      var m = node.nodeValue.match(RE);
      if (m){ target = node; match = m; break; }
    }
    if (!target) return;

    root.setAttribute('data-ykcpn', '1');

    var code = match[1];
    var full = target.nodeValue;
    var idx = full.indexOf(code);
    var before = full.slice(0, idx);
    var after  = full.slice(idx + code.length);

    var frag = document.createDocumentFragment();
    if (before) frag.appendChild(document.createTextNode(before));
    frag.appendChild(makeChip(code));
    if (after) frag.appendChild(document.createTextNode(after));

    target.parentNode.replaceChild(frag, target);
  }

  function run(){
    var offers = document.querySelectorAll('.pp__offer');
    for (var i = 0; i < offers.length; i++) scan(offers[i]);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }

  setTimeout(run, 400);
  setTimeout(run, 1200);
  window.addEventListener('load', run);

  try {
    new MutationObserver(function(){ run(); })
      .observe(document.body, { childList:true, subtree:true });
  } catch(e){}
})();